/**
 * ============================================================================
 * NOTIFICATION BADGE COMPONENT - 100% Ready
 * ============================================================================
 * 
 * Badge showing unread notification count
 */

import React from 'react';

/**
 * Notification Badge Component
 * @param {Object} props
 * @param {number} props.count - Unread count
 * @param {string} props.size - Size (sm, md, lg)
 * @param {string} props.variant - Variant (default, pulse, bounce)
 * @param {string} props.className - Additional classes
 * @returns {JSX.Element}
 */
const NotificationBadge = ({
  count = 0,
  size = 'md',
  variant = 'default',
  className = '',
}) => {
  if (count === 0) return null;

  const sizeClasses = {
    sm: 'w-4 h-4 text-xs',
    md: 'w-5 h-5 text-xs',
    lg: 'w-6 h-6 text-sm',
  };

  const displayCount = count > 99 ? '99+' : count;

  const variantClasses = {
    default: 'bg-red-500 text-white',
    pulse: 'bg-red-500 text-white animate-pulse',
    bounce: 'bg-red-500 text-white animate-bounce',
  };

  return (
    <span
      className={`
        absolute -top-1 -right-1
        ${sizeClasses[size] || sizeClasses.md}
        ${variantClasses[variant] || variantClasses.default}
        rounded-full
        flex items-center justify-center
        font-bold
        shadow-lg
        border-2 border-white dark:border-gray-800
        ${className}
      `}
      aria-label={`${count} unread notifications`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;
